export default {
  crm: {
    common: {
      save: 'Kaydet',
      saveInformation: 'Bilgileri Kaydet',
      updateInformation: 'Bilgileri Güncelle',
      update: 'Güncelle',
      new: 'Yeni',
      edit: 'Düzelt',
      delete: 'Sil',
      actions: 'İşlemler',
      id: 'Id',
      deleteQuestion: 'Silmek istediğinizden emin misiniz?',
      deletePerson: 'Kişi Silme',
      internalPhone: 'Dahili',
      phTelecomNumber: ' giriniz',
      errorLookupFileds: 'İlgili Bilgiler Yüklenemedi!',
      dashboard: 'Müşteri Genel Görünüm',
      contactInformation: 'İletişim Bilgileri',
      addContact: 'İletişim  Ekle',
      addAddress: 'Adres Ekle',
      newParam: 'Yeni Parametre',
      refresh: 'Yenile',
      createParty: 'Muhatap Oluştur',
      errorAllValues: 'Bilgiler alınırken gata alındı!',
      deleteParty: 'Muhatap Silme',
      unArchiveQuestion: 'Kaydı aktif hale getirmek istediğinizden emin misiniz?'
    },
    screenName: {
      personCreateIdentity: 'Kimlik',
      personCreateAddress: 'Adres',
      personCreateContact: 'İletişim',
      personCreateJob: 'Meslek'
    },
    personList: {
      partyType: 'Müşteri Tipi',
      partyId: 'Muhatap No',
      status: 'Muhatap Durumu',
      partyName: 'Adı & Soyadı',
      identification: 'Kimlik Numarası',
      view: 'Müşteri Güncelle',
      delete: 'Müşteri Sil',
      birthDay: 'Doğum Tarihi',
      actives: 'Aktif',
      archives: 'Pasif'
    },
    relationPatternCreate: {
      relationPatternDialogTitle: 'İlişki Kalıp Tanımı',
      fromPartySection: 'İlişki Kuran Muhatap',
      toPartySection: 'İlişki Kurulcak Muhatap',
      patternName: 'Kalıp Adı',
      relationshipType: 'İlişki Tipi',
      permissionType: 'İzin Tipi',
      fromPartyType: 'Muhatap Tipi',
      fromRoleType: 'Rol Tipi',
      fromAutoRoleInsert: 'Otomatik Kayıt',
      fromPhrase: 'Kısa Ad',
      fromPhrases: 'Kısa Adlar',
      fromMinCard: 'Min Kişi',
      fromMaxCard: 'Max Kişi',
      toPartyType: 'Muhatap Tipi',
      toRoleType: 'Rol Tipi',
      toAutoRoleInsert: 'Otomatik Kayıt',
      toPhrase: 'Kısa Ad',
      toPhrases: 'Kısa Adlar',
      toMinCard: 'Min Kişi',
      toMaxCard: 'Max Kişi',
      comment: 'Açıklama',
      phPatternName: 'Kalıp adı giriniz.',
      phRelationshipType: 'İlişki tipi seçiniz.',
      phPermissionType: 'İzin tipi seçiniz.',
      phFromPartyType: 'Muhatap tipi seçiniz.',
      phFromRoleType: 'Rol tipi seçiniz.',
      phFromPhrase: 'Kısa ad giriniz.',
      phFromPhrases: 'Kısa adlar giriniz.',
      phToPartyType: 'Muhatap tipi seçiniz.',
      phToRoleType: 'Rol tipi seçiniz.',
      phToPhrase: 'Kısa ad giriniz.',
      phToPhrases: 'Kısa adlar giriniz.',
      phComment: 'Açıklama yazınız.',
      valRequiredPatterntName: 'Kalıp adı girmek zorunludur',
      valRequiredRelationshipType: 'İlişki tipi seçimi zorunludur',
      valRequiredPermissionType: 'İzin tipi seçimi zorunludur',
      valRequiredFromPartyType: 'Muhatap tipi seçimi zorunludur',
      valRequiredToPartyType: 'Muhatap tipi seçimi zorunludur',
      valRequiredFromRoleType: 'Rol seçimi zorunludur',
      valRequiredToRoleType: 'Rol seçimi zorunludur'
    },
    relationCreate: {
      relationDialogTitle: 'İlişki Tanımı',
      relationShipType: 'İlişki Tipi',
      fromParty: 'İlişki Kuracak Muhatap',
      toParty: 'İlişki Kurulcak Muhatap',
      relationShipName: 'İlişki Adı',
      priorityType: 'Öncelik',
      commment: 'Yorum',
      id: 'Id',
      phRelationShipType: 'İlişki tipi seçiniz.',
      phFromParty: 'İlişki kuracak muhatap seçiniz.',
      phToParty: 'İlişki kurulcak muhatap seçiniz.',
      phRelationShipName: 'İlişki adı giriniz.',
      phPriorityType: 'Öncelik seçiniz.',
      phCommment: 'Yorum yazınız.',
      valRequiredRelationShipName: 'İlişki adı giriniz',
      valRequiredRelationShipType: 'İlişki tipi giriniz',
      valRequiredFromParty: 'Muhatap girilmesi zorunludur',
      valRequiredToParty: 'Muhatap girilmesi zorundluru'
    },
    address: {
      recipientName: 'Alıcı Adı',
      neighborhood: 'Mahalle',
      addressType: 'Adres Tipi',
      mainRoad: 'Cadde',
      country: 'Ülke',
      street: 'Sokak',
      province: 'İl',
      block: 'Site',
      buildingName: 'Bina Adı',
      district: 'İlçe',
      buildingNumber: 'Bina No',
      floor: 'Kat',
      flatNumber: 'Kapı No',
      postalCode: 'Posta Kodu',
      firstContactDatePH: 'İlk İletişim Tarihini Giriniz',
      phRecipientName: 'Alıcı adını giriniz.',
      phNeighborhood: 'Mahalle adını giriniz.',
      phAddressType: 'Adres tipini seçiniz.',
      phMainRoad: 'Cadde adını giriniz.',
      phCountry: 'Ülke adını seçiniz.',
      phStreet: 'Sokak adını giriniz.',
      phProvince: 'İl adını seçiniz.',
      phBlock: 'Site bilgilerini giriniz.',
      phFloor: 'Kat bilgisini giriniz.',
      phFlatNumber: 'Kapı numarasını giriniz.',
      phBuildingName: 'Bina adını giriniz.',
      phDistrict: 'İlçe adını seçiniz.',
      phBuildingNumber: 'Bina numarasını giriniz.',
      phPostalCode: 'Posta kodunu giriniz.'
    },
    personCreate: {
      branch: 'Şube',
      tckn: 'TCKN',
      gender: 'Cinsiyet',
      firstName: 'Adı',
      middleName: 'İkinci Adı',
      lastName: 'Soyadı',
      dateOfBirth: 'Doğum Tarihi',
      preferedLanguage: 'İletişim Tercih Dili',
      phBranch: 'Şube Bilgisini Giriniz',
      phDateOfBirth: 'Doğum Tarihini Giriniz',
      phTckn: 'TCKN Giriniz',
      phGender: 'Cinsiyet Giriniz',
      phFirstName: 'Ad Giriniz',
      phMiddleName: 'İkinici İsim Giriniz',
      phLastName: 'Soyad Giriniz',
      phPreferedLanguage: 'Tercih Edilen Dili Seçiniz',
      valRequiredFirstName: 'Ad girilmesi zorunludur',
      valFirstName: '2 ile 250 arasında karakter giriniz',
      valMiddleName: '2 ile 250 arasında karakter giriniz',
      valRequiredLastName: 'Soyad girilmesi zorunludur',
      valLastName: '2 ile 250 arasında karakter giriniz'
    },
    quickPersonCreate: {
      firstName: 'Adı',
      middleName: 'İkinci Adı',
      lastName: 'Soyadı',
      telNo: 'Telefon Numarası',
      phFirstName: 'Ad giriniz.',
      phMiddleName: 'İkinci ad giriniz.',
      phLastName: 'Soyad giriniz.',
      valRequiredFirstName: 'Ad girilmesi zorunludur',
      valFirstName: '2 ile 250 arasında karakter giriniz',
      valMiddleName: '2 ile 250 arasında karakter giriniz',
      valRequiredLastName: 'Soyad girilmesi zorunludur',
      valLastName: '2 ile 250 arasında karakter giriniz',
      valRequiredTelNo: 'Telefon girilmesi zorunludur'
    },
    personCreateIdentity: {
      placeOfBirth: 'Doğum Yeri',
      homeCountry: 'Yerleşim Ülkesi',
      fatherName: 'Baba Adı',
      motherName: 'Ana Adı',
      citizenshipStatus: 'Vatandaşlık Durumu',
      nationality: 'Uyruk',
      kvkStatus: 'KVK Durumu',
      phPlaceOfBirth: 'Doğum Yerini Giriniz',
      phHomeCountry: 'Yerleşim Ülkesini Giriniz',
      phFatherName: 'Baba Adını Giriniz',
      phMotherName: 'Anne Adını Giriniz',
      phNationality: 'Uyruğunu Giriniz',
      phCitizenshipStatus: 'Vatanadaşlık Durumunu Giriniz',
      phKvkStatus: 'KVK Durumunu Giriniz',
      valFatherName: '2 ile 250 arasında karakter giriniz',
      valMotherName: '2 ile 250 arasında karakter giriniz',
      valMotherMaidenName: '2 ile 250 arasında karakter giriniz',
      errorProvinceList: 'İl Bilgileri yüklenirken hata alındı'
    },
    personCreateJob: {
      employmentStatus: 'Çalışma Şekli',
      personalTitle: 'Unvan',
      occupation: 'Meslek',
      incomeGroup: 'Gelir Grubu',
      phEmploymentStatus: 'Çalışma Şekli Giriniz',
      phPersonalTitle: 'Unvan Giriniz',
      phOccupation: 'Meslek Giriniz',
      phIncomeGroup: 'Gelir Grubunu Giriniz'
    },
    personEdit: {
      partyId: 'Muhatap Numarası',
      segment: 'Segment',
      partyRoleType: 'Muhatap Türü',
      behaviourSegment: 'Davranış Segmenti',
      portfolio: 'Portföy',
      partyName: 'Muhatap Adı',
      riskStatus: 'Risk Sınıfı',
      partyStatus: 'Muhatap Durumu',
      phPartyId: 'Muhatap Numarası Giriniz',
      phSegment: 'Segment Seçiniz',
      phPartyRoleType: 'Muhatap Türü Giriniz',
      phBehaviourSegment: 'Davranış Segmenti Seçiniz',
      phPortfolio: 'Portföy Seçiniz',
      phPartyName: 'Muhatap Adı Giriniz',
      phRiskStatus: 'Risk Sınıfı Seçiniz',
      phPartyStatus: 'Muhatap Durumu Seçiniz',
      updatePerson: 'Muhatap Güncelleme'
    },
    personEditGeneral: {
      branch: 'Şube',
      citizenshipStatus: 'Vatandaşlık Durumu',
      nationality: 'Uyruk',
      homeCountry: 'Yerleşim Ülkesi',
      legalCapacity: 'Fiili Ehliyet',
      placeOfBirth: 'Doğum Yeri',
      disabledType: 'Engel Türü',
      kvkStatus: 'Kvk Durumu',
      tckn: 'TCKN',
      nativeLanguage: 'Ana Dil',
      firstName: 'Adı',
      preferedLanguage: 'İletişim Tercih Dili',
      middleName: 'İkinci Adı',
      lastName: 'Soyadı',
      motherMaidenName: 'Anne Kızlık Soyadı',
      maidenName: 'Kızlık Soyadı',
      fatherName: 'Baba Adı',
      motherName: 'Ana Adı',
      dateOfBirth: 'Doğum Tarihi',
      portfolio: 'Portföy',
      phBranch: 'Şube Bilgisini Giriniz',
      phCitizenshipStatus: 'Vatanadaşlık Durumunu Giriniz',
      phNationality: 'Uyruk Seçiniz',
      phHomeCountry: 'Yerleşim Ülkesini Giriniz',
      phLegalCapacity: 'Fiili Ehliyet Giriniz',
      phPlaceOfBirth: 'Doğum Yeri Giriniz',
      phDisabledType: 'Engel Türü Seçiniz',
      phKvkStatus: 'Kvk Durumu Seçiniz',
      phTckn: 'TCKN Giriniz',
      phNativeLanguage: 'Ana Dil Seçiniz',
      phFirstName: 'İsim Giriniz',
      phMiddleName: 'İkinci İsim Giriniz',
      phMotherMaidenName: 'Anne Kızlık Soyadı Giriniz',
      phPreferedLanguage: 'Tercih Edilen Dili Seçiniz',
      phLastName: 'Soyad Giriniz',
      phMaidenName: 'Kızlık Soyadı Giriniz',
      phFatherName: 'Baba Adını Giriniz',
      phMotherName: 'Ana Adı Giriniz',
      phDateOfBirth: 'Doğum Tarihini Giriniz',
      phPortfolio: 'Portföy Seçiniz',
      valMaidenName: '2 ile 250 arasında karakter giriniz'
    },
    personEditHouse: {
      personAthome: 'Evdeki Kişi Sayısı',
      childCount: 'Çocuk Sayısı',
      personResponsible: 'Baktığı Kişi Sayısı',
      childAthome: 'Evdeki Çocuk Sayısı',
      homeStatus: 'Evin Durumu',
      stayingYear: 'Oturma Yılı',
      phPersonAthome: 'Evdeki Kişi Sayısı giriniz',
      phchildCount: 'Çocuk Sayısını giriniz',
      phPersonResponsible: 'Baktığı Kişi Sayısını giriniz',
      phChildAthome: 'Evdeki Çocuk Sayısını giriniz',
      phHomeStatus: 'Oturduğu Evin Durumunu giriniz',
      phStayingYear: 'Kaç Senedir Oturuyor Bilgisini giriniz'
    },
    personEditWorkingLife: {
      employmentStatus: 'Çalışma Tipi',
      personalTitle: 'Unvan',
      occupation: 'Meslek',
      incomeGroup: 'Gelir Grubu',
      businessScope: 'Faaliyet Alanı',
      employmentOrganizationName: 'İş Yeri Adı',
      employmentPlaceAdress: 'İş Yeri Adresi',
      employmentDate: 'İşe Başlama Tarihi',
      phEmploymentStatus: 'Çalışma tipi seçiniz',
      phEmploymentOrganizationName: 'İş yeri adını giriniz',
      phEmploymentPlaceAdress: 'İş adresi giriniz',
      phPersonalTitle: 'Unvan seçiniz',
      phOccupation: 'Meslek Seçiniz',
      phIncomeGroup: 'Gelir Grubu',
      phEmploymentDate: 'İşe başlama tarihi giriniz',
      phBusinessScope: 'Faaliyet alanı seçiniz'
    },
    personEditIdentity: {
      identificationNumber: 'TC Kimlik No',
      fatherName: 'Baba Adı',
      serialNumber: 'Seri No',
      motherName: 'Ana Adı',
      nationality: 'Uyruk',
      dateOfBirth: 'Doğum tarihi',
      firstName: 'Adı',
      middleName: 'İkinci Adı',
      lastName: 'Soyadı',
      gender: 'Cinsiyet',
      validUntilDate: 'Geçerlilik Tarihi',
      phIdentificationNumber: 'TC numarası giriniz.',
      phFatherName: 'Baba adı giriniz.',
      phMotherName: 'Ana adını giriniz.',
      phSerialNumber: 'Seri numarası giriniz',
      serialNumberRequired: 'Seri no zorunludur',
      phNationality: 'Uyruk seçiniz.',
      phFirstName: 'Ad giriniz.',
      phMiddleName: 'İkinci ad giriniz.',
      phLastName: 'Soyad giriniz',
      phGender: 'Cinsiyet seçiniz',
      phDateOfBirth: 'Doğum tarihi giriniz.',
      phValidUntilDate: 'Geçerlilik tarihi giriniz.',
      valRequiredFirstName: 'İsim girilmesi zorunludur',
      valRequiredFatherName: 'Baba adı girilmesi zorunludur',
      valRequiredMotherName: 'Seri no girilmesi zorunludur',
      valRequiredCitizenship: 'Uyruk seçimi zorunludur',
      valRequiredValidUntilDate: 'Geçerlilik tarihi zorunludur',
      valRequiredBirthDay: 'Doğum tarihi zorunldur',
      valRequiredGender: 'Cinsiyet seçiimi zorunldur',
      valRequiredLastName: 'Soyadı girilmesi zorunludur'
    },
    personEditDrivingLicense: {
      documentNo: 'Belge No',
      province: 'Verildiği İl',
      drivingClass: 'Ehliyet Sınıfı',
      district: 'Verildiği İlçe',
      licenseDate: 'Veriliş Tarihi',
      phDocumentNo: 'Belge no giriniz.',
      phProvince: 'Verildiği il seçiniz.',
      phDrivingClass: 'Ehliyet sınıfı seçiniz.',
      phDistrict: 'Verildiği ilçe seçiniz.',
      phLicenseDate: 'Veriliş tarihi giriniz.',
      valRequiredDocumentNo: 'Belge No girilmesi zorunludur',
      valRequiredIssuedProvinceGeoId: 'İl seçimi zorunludur',
      valRequiredDrivingClass: 'Ehliyet Sınıfı seçimi zorunludur',
      valRequiredIssuedDistrictGeoId: 'ilçe seçimi zorunludur',
      valRequiredLicenseDate: 'Veriliş tarihi bilgisi zorunludur'
    },
    personEditPassport: {
      name: 'Adı',
      lastName: 'Soyad',
      gender: 'Cinsiyet',
      nationality: 'Uyruk',
      authOffice: 'Veren Makam',
      identificationNumber: 'Kimlik Numarası',
      birthDay: 'Doğum Günü',
      birthCity: 'Doğum Yeri',
      validUntilDate: 'Geçerlilik Tarihi',
      passportNumber: 'Pasaport Numarası',
      issueDate: 'Düzenleme Tarihi',
      phName: 'Adı giriniz.',
      phLastName: 'Soyad giriniz.',
      phGender: 'Cinsiyet seçiniz.',
      phNationality: 'Uyruk seçiniz.',
      phAuthOffice: 'Veren makam giriniz.',
      phIdentificationNumber: 'Kimlik numarası giriniz.',
      phBirthDay: 'Doğum günü giriniz.',
      phBirthCity: 'Doğum yeri seçiniz.',
      phValidUntilDate: 'Geçerlilik tarihi giriniz.',
      phPassportNumber: 'Pasaport numarası giriniz.',
      phIssueDate: 'Düzenleme tarihi giriniz.',
      valRequiredPassportNumber: 'Pasaport Numarası girilmesi zorunludur',
      valRequiredName: 'Ad girilmesi zorunludur',
      valRequiredGender: 'Cinsiyet seçimi zorunludur',
      valRequiredLastName: 'Soyad girilmesi zorunludur',
      valRequiredCitizenship: 'Uyruk seçimi zorunludur',
      valRequiredAuthOffice: 'Veren makam girilmesi zorunludur',
      valRequiredBirthDay: 'Doğum tarihi seçilmesi zorunludur',
      valRequiredBirthPlace: 'Doğum tarihi seçilmesi zorunludur',
      valRequiredUntilDate: 'Geçerlilik tarihi seçilmesi zorunludur',
      valRequiredIssueDate: 'Düzenleme tarihi seçilmesi zorunludur'
    },
    personEditResidencePermit: {
      foreignersId: 'Yabancı Kimlik No',
      nationality: 'Uyruk',
      firstName: 'Adı',
      typeOfResidencePermit: 'İkamet Türü',
      lastName: 'Soyadı',
      issueDate: 'Düzenleme Tarihi',
      birthDate: 'Doğum Tarihi',
      provinceOfResidence: 'İkamet İli',
      validFromDate: 'Başlangıç Tarihi',
      validUntilDate: 'Bitiş Tarihi',
      phForeignersId: 'Yabancı kimlik no giriniz.',
      phNationality: 'Uyruk seçimi yapınız.',
      phFirstName: 'Ad giriniz.',
      phTypeOfResidencePermit: 'İkamet türü seçiniz.',
      phLastName: 'Soyad giriniz.',
      phIssueDate: 'Düzenleme tarihi giriniz.',
      phBirthDay: 'Doğum tarihi giriniz.',
      phProvinceOfResidence: 'İkamet ili giriniz.',
      phValidFromDate: 'Başlangıç tarihi giriniz.',
      phValidUntilDate: 'Bitiş tarihi giriniz.'
    },
    personEditEducation: {
      educationBackground: 'Öğrenim Durumu',
      lastSchoolName: 'Son Bitirilen Okul',
      graduatedDate: 'Mezuniyet Tarihi',
      foreignLanguage: 'Yabancı Diller',
      militaryStatus: 'Askerlik Durumu',
      phEducationBackground: 'Öğrenim durumu seçiniz.',
      phLastSchoolName: 'Son bitirilen okul giriniz.',
      phGraduatedDate: 'Mezuniyet tarihi giriniz.',
      phForeignLanguage: 'Yabanci dil seçimiz yapınız.',
      phMilitaryStatus: 'Askerlik durumu seçiniz.'
    },
    organization: {
      branch: 'Şube',
      homeCountry: 'Yerleşim Ülkesi',
      identificationNumber: 'Vergi Kimlik No',
      taxOfficeName: 'Vergi Dairesi',
      groupName: 'Unvan',
      groupNameShort: 'Kısa Ad',
      fullName: 'Organizasyon Tüm Adı',
      phFullName: 'Organizasyon tüm adı giriniz',
      phBranch: 'Şube Bilgisini Giriniz',
      phHomeCountry: 'Yerleşim Ülkesini Giriniz',
      phTaxOfficeName: 'Vergi Dairesi Giriniz',
      phIdentificationNumber: 'Vergi Kimlik Numarası Giriniz',
      phGroupName: 'Unvan Giriniz',
      phGroupNameShort: 'Kısa İsim Giriniz',
      valGroupName: 'Unvan girilmesi zorunludur'
    },
    organizationContacts: {
      basePhone: 'Merkezi Telefon',
      factoryPhone: 'Fabrika',
      fax: 'Fax',
      branchPhone: 'Şube',
      eMail: 'E-Mail',
      webAdress: 'Web Adresi',
      phBasePhone: 'Merkezi Telefon Giriniz',
      phFax: 'Fax Giriniz',
      phFactoryPhone: 'Fabrika Telefonu Giriniz',
      phBranchPhone: 'Şube Telefonu Giriniz',
      phEmail: 'E-Mail Bilgisi Giriniz',
      phWebAdress: 'Web Adresi Bilgisi Giriniz'
    },
    parameterIncomeType: {
      incomeTypeDialogTitle: 'Gelir Tanımı',
      name: 'Adı',
      description: 'Açıklaması',
      phName: 'Muhatap gelir tanım adı giriniz.',
      phDescription: 'Muhatap gelir açıklaması adı giriniz.',
      valNameRequired: 'Muhatap gelir tanım adı girmek zorunnludur',
      valName: '2 ile 250 arasında karakter giriniz.',
      valDescription: '2 ile 500 arasında karakter giriniz.',
      errorIncomeTypeValues: 'Muhatap gelir tanımları alınırken hata alındı.'
    },
    parameterPartyIncome: {
      partyIncomeDialogTitle: 'Muhatap Gelir Tanımı',
      partyId: 'Muhatap',
      incomeType: 'Gelir Tipi',
      price: 'Tutar',
      comments: 'Yorum',
      phPartyId: 'Muhatap seçiniz',
      phIncomeType: 'Gelir Tipi seçiniz',
      phPrice: 'Tutar giriniz',
      phComments: 'Yorum giriniz'
    },
    parameterSegment: {
      segmentDialogTitle: 'Segment Tanımı',
      segmentType: 'Türü',
      segmentName: 'Adı',
      segmentDescription: 'Açıklaması',
      deleteLabel: 'Segment Türü Silme',
      phSegmentType: 'Segment tanım türü seçiniz.',
      phSegmentName: 'Segment tanım adı giriniz.',
      phSegmentDescription: 'Segment tanım açıklaması giriniz.',
      valSegmentType: 'Segment türü girmek zorunludur',
      valSegmentNameRequired: 'Segment adı girmek zorunludur',
      errorSegmentTypes: 'Segment türleri bilgisi alınırken hata oluştu!',
      errorSegmentValues: 'Segment bilgileri alınırken hata oluştu!'
    },
    parameterRelationType: {
      relationTypeDialogTitle: 'Muhatap İlişki Tipi Tanımı',
      relationName: 'Adı',
      relationDescription: 'Açıklaması',
      relationHasOwnScreen: 'Tanımlı mı',
      phRelationName: 'Muhatap ilişki tanım adı giriniz.',
      phRelationDescription: 'Muhatap ilişki tanım açıklaması giriniz.',
      valRelationTypeNameRequired: 'Muhatap ilişki tanım adı girmek zorunnludur',
      valName: '2 ile 250 arasında karakter giriniz.',
      valDescription: '2 ile 500 arasında karakter giriniz.',
      errorRelationTypeValues: 'Muhatap ilişki tanımları alınırken hata alındı.'
    },
    parameterRoleType: {
      roleTypeDialogTitle: 'Muhatap Rol Tanımı',
      roleName: 'Adı',
      roleDescription: 'Açıklaması',
      phRoleName: 'Muhatap rol tanım adı giriniz.',
      phRoleDescription: 'Muhatap rol açıklaması adı giriniz.',
      valRoleTypeNameRequired: 'Muhatap rol tanım adı girmek zorunnludur',
      valName: '2 ile 250 arasında karakter giriniz.',
      valDescription: '2 ile 500 arasında karakter giriniz.',
      errorRoleTypeValues: 'Muhatap rol tanımları alınırken hata alındı.'
    },
    parameterClassification: {
      classificationDialogTitle: 'Sınıflandırma Tanımı',
      classificationType: 'Türü',
      categoryName: 'Adı',
      categoryDescription: 'Açıklaması',
      categoryNumber: 'Kategori Numarası',
      edit: 'Düzelt',
      delete: 'Sil',
      new: 'Yeni',
      save: 'Kaydet',
      phCategoryType: 'Sınıflandırma tanım türü seçiniz.',
      phCategoryName: 'Sınıflandırma tanım adı giriniz.',
      phCategoryDescription: 'Sınıflandırma tanım açıklaması giriniz.',
      valCategoryType: 'Sınıflandırma tanım türü seçmek zorunludur.',
      valCategoryNameRequired: 'Sınıflandırma tanım adı girmek zorunludur.',
      valCategoryName: '2 ile 250 arasında karakter giriniz.',
      valCategoryDescription: '2 ile 250 arasında karakter giriniz.',
      errorClassificationTypes: 'Sınıflandırma tür bilgileri alınamadı.',
      errorClassificationValues: 'Sınıflandırma değerleri alınamadı.'
    },
    parameterClassificationMap: {
      dialogTitle: 'Sınıflandırma Tanım İlişkilendirme',
      classificationMapType: 'İlişkilendirme Türü',
      classificationType: 'Türü',
      classificationIdTo: 'Tanım',
      classificationIdFrom: 'İlişkili Tanım',
      id: 'Id',
      phClassificationMapType: 'Sınıflandırma türü seçiniz.',
      phClassificatioIdTo: 'Sınıflandırma tanımı seçiniz.',
      phClassificationIdFrom: 'İlişkili sınıflandırma tanımı seçiniz.',
      valClassificationMapType: 'Sınıflandırma ilişkilendirme türü seçmek zorunludur.',
      valClassificationIdTo: 'Sınıflandırma tanımı seçmek zorunludur.',
      valClassificationIdFrom: 'İlişkili sınıflandırma tanım seçmek zorunludur.',
      deleteLabel: 'Sınıflandırma Tanım İlişkisi Silme'
    },
    parameterGeo: {
      geoDialogTitle: 'Coğrafi Tanım',
      type: 'Türü',
      geoName: 'Adı',
      integrationCode: 'Entegre Kodu',
      additionalCode: 'Ek Kodu',
      dialingCode: 'Telefon Kodu',
      isoCode: 'İso Kodu',
      isoCodeShort: 'İso Kısa Kodu',
      description: 'Açıklama',
      geoId: 'Geo Id',
      isActive: 'Aktif',
      deleteLabel: 'Coğrafi Tanım Silme',
      phGeoType: 'Coğrafi tanım türü seçiniz.',
      phGeoName: 'Coğrafi tanım adı giriniz.',
      phIsoCode: 'İso kod giriniz.',
      phIsoCodeShort: 'İso kod kısaltmasını giriniz.',
      phIntegrationCode: 'Entegre kod giriniz.',
      phAdditionalCode: 'Ek kod giriniz.',
      phDialingCode: 'Telefon kodu giriniz.',
      phDescription: 'Açıklama giriniz.',
      valGeoType: 'Coğrafi tür seçmek zorunludur.',
      valGeoName: '2 ile 250 arasında karakter giriniz.',
      valGeoNameRequired: 'Coğrafi tanım adı girmek zorunludur.',
      valGeoCode: '2 ile 250 arasında karakter giriniz.',
      valGeoSecCode: '2 ile 250 arasında karakter giriniz.',
      valAbbreviation: '2 ile 250 arasında karakter giriniz.',
      valIntegrationCode: '2 ile 250 arasında karakter giriniz.',
      valCallingCode: '2 ile 250 arasında karakter giriniz.',
      valDescription: '2 ile 250 arasında karakter giriniz.',
      errorGeoTypes: 'Coğrafi Tür Bilgileri alınamadı.',
      errorGeoValues: 'Coğrafi Tanım Listesi alınamadı.',
      actives: 'Aktif',
      archives: 'Arşiv'
    },
    parameterGeoMap: {
      geoMapDialogTitle: 'Coğrafi Tanım İlişkilendirme',
      geoAssocType: 'İlişkilendirme Türü',
      geoIdTo: 'Tanım',
      geoId: 'İlişkili Tanım',
      id: 'Id',
      deleteLabel: 'Coğrafi Tanım İlişkisi Silme',
      phGeoMapGeoAssocType: 'İlişkilendirme türü seçiniz.',
      phGeoMapGeoIdTo: 'Coğrafi tanım seçiniz.',
      phGeoMapGeoId: 'İlişkili coğrafi tanım seçiniz.',
      valGeoAssocType: 'Coğrafi ilişkilendirme türü seçmek zorunludur.',
      valGeoIdTo: 'Coğrafi tanımı seçmek zorunludur.',
      valGeoId: 'İlişkili coğrafi tanım seçmek zorunludur.',
      errorGeoAssocTypes: 'İlişkili Coğrafi Tanım Bilgileri alınamadı.',
      errorAllGeoAssocValues: 'İlişkili Coğrafi Tanım Listesi alınamadı.',
      errorLookupFields: 'Ekranda Gerekli Alanlar alınamadı.'
    },
    parameterContactMechPurposeType: {
      dialogTitle: 'İletişim Amaç Tanımı',
      id: 'Kayıt Numarası',
      name: 'Tanım',
      description: 'Açıklama',
      deleteRoleLabel: 'İletişim Amacı Tanım silme',
      phName: 'İletişim amaç tanımı giriniz.',
      phDescription: 'İletişim amaç açıklaması giriniz.',
      valNameRequired: 'İletişim amaç tanımı girmek zorunludur.',
      valName: '2 ile 250 arasında karakter giriniz.',
      valDescription: '2 ile 250 arasında karakter giriniz.',
      actives: 'Aktif',
      archives: 'Arşiv',
      unArchieveLabel: 'Aktifleştirme',
      errorGetAllValues: 'İletişim Amaç Bilgileri alınamadı.'
    },
    parameterContactMechPurposeTypeMap: {
      dialogTitle: 'İletişim Amacı İlişkilendirme',
      contactMechType: 'İletişim Türü',
      purposeType: 'İletişim Amacı',
      partyType: 'Muhatap Türü',
      id: 'Id',
      deleteRoleLabel: 'İletişim İlişkisi Silme',
      phContactMechType: 'İletişim türü seçiniz.',
      phPurposeType: 'İletişim amacı seçiniz.',
      phPartyType: 'Muhatap türü seçiniz.',
      valContactMechTypeRequired: 'İletişim türleri bilgisi zorunludur.',
      valPurposeTypeRequired: 'İletişim açamları bilgisi zorunludur.',
      valPartyTypeequired: 'Muhatap türü bilgisi zorunludur.',
      errorAllValues: 'Bilgiler alınırken hata alındı',
      errorContactMechTypes: 'İletişim Tipleri Bilgisi alınırken hata alındı',
      errorPurposeTypeList: 'İletişim Amaçları Bilgisi alınırken hata alındı',
      errorPartyTypes: 'Muhatap Türleri Bilgisi alınırken hata alındı'
    },
    error: {
      notExistPattern: 'Seçtiğiniz tasarım kalıbı, kullanıma kapanmıştır',
      notMoreRelation: 'İlişki kalıbı maksimum ilişki sayısına ulaşmıştır',
      existRelation: 'Aynı ilişki adı sistemimizde bulunmaktadır.',
      sameRelation: 'Finansman Planı sahibi kendine kefil olamaz.',
      notExistPartyRole: 'İlgili muhataba ait bir rol bulunamadı.',
      existClassification: 'Aynı sınıf tipinde bir kayıt bulunmaktadır.',
      existGeo: 'Girmek istediğiniz coğrafi tanım, sistemde bulunmaktadır. Lütfen coğrafi tipi ve adı kontrol ediniz.',
      existGeoMap: 'Girmek istediğiniz coğrafi ilişkilendirme, sistemde bulunmaktadır.',
      existSegment: 'Girmek istediğiniz segment tanımı, sistemde bulunmaktadır.',
      existRelationType: 'Girmek istediğiniz muhatap ilişki tanımı, sistemde bulunmaktadır.',
      existContactMechPurposeType: 'Girmek istediğiniz iletişim amaç tanımı, sistemde bulunmaktadır.',
      existContactMechPurposeTypeMap: 'Girmek istediğiniz iletişim amacı ilişkilendirme, sistemde bulunmaktadır.',
      existIdentificationNumber: 'Girmek istediğiniz kimlik numarası sistemimizde bulunmaktadır.',
      createPersonException: 'Lütfen muhatabın Ad, Soyad ve en az bir iletişim bilgisini giriniz.',
      createPersonContactMechException: 'Girmek istediğiniz Telefon numarası ile uyuşan muhatap kaydı bulunmaktadır, lütfen bilgileri kontrol ediniz.',
      personAddressException: 'Lütfen mahalle, sokak veya cadde alanlarından en az birini doldurunuz.',
      errorTelNo: 'Hatalı Telefon Numarası',
      requiredReceiverName: 'Alıcı adı girilmesi zorunludur',
      requiredAddressType: 'Adres tip seçimi zorunludur',
      requiredCountry: 'Ülke seçimi zorunludur',
      requiredProvince: 'Şehir seçimi zorunludur',
      requiredDistrcit: 'İlçe seçimi zorunludur',
      requiredFlatNumber: 'Kapı no girilmesi zorunludur',
      requiredEducation: 'Öğrenim durumu seçilmesi zorunludur',
      requiredEmploymentStatus: 'Çalışma tipi seçimi zorunludur',
      requiredOccupation: 'Meslek seçimi zorunludur',
      requiredHomeStatus: 'Ev durumu seçimi zorunludur',
      existIncome: 'Benzer gelir tipi sistemde bulunmaktadır.',
      verifiedEmail: 'E-Posta zaten onaylanmıştır.',
      codeNotFound: 'Onay kodu bulunamadı.',
      emailVerifyTimeOut: 'Doğrulama kodu zaman aşımına uğradı.',
      unknown: 'Bilinmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyeniz.'
    }
  }
};